export default __webpack_public_path__ + "7a6e8db18f628785cb737ca13c342f67.jpg";